import { useCallback, useEffect, useState } from 'react';
import sessionsApi from 'Api/axios/sessions-api';

/**
 * Single responsibility: own the page-local cache of sessions for a course.
 * Exposes the fetch-on-demand surface used by the listing tab.
 */
export default function useSessionsListApi({ courseId, init = true } = {}) {
  const [data, setData] = useState([]);
  const [pagination, setPagination] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchSessions = useCallback(
    async ({ search, status, page = 1, limit = 50 } = {}) => {
      if (!courseId) return { data: [], error: null };
      setLoading(true);
      setError(null);
      const response = await sessionsApi.list({
        courseId,
        page,
        limit,
        search: search || undefined,
        status: status || undefined,
      });
      if (response.error) {
        setError(response.error);
        setData([]);
        setPagination(null);
      } else {
        setData(response.data || []);
        setPagination(response.pagination || null);
      }
      setLoading(false);
      return response;
    },
    [courseId]
  );

  useEffect(() => {
    if (init && courseId) {
      fetchSessions();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [courseId, init]);

  return { data, pagination, loading, error, fetchSessions };
}
